export default "__VITE_ASSET__BKcWvKNL__"